import React from 'react'

// ─────────────────────────────────────────────────────────────────────────────
// Toggle switch , orange track when on. Optional label + hint.
//
//   <Toggle checked={x} onChange={fn} label="Pflichtfrage" hint="…" />
//
// If you don't need a label, wrap your own around <ToggleSwitch> directly.
// ─────────────────────────────────────────────────────────────────────────────

export function ToggleSwitch({ checked, onChange, ariaLabel, size = 'default', disabled = false }) {
  const s = size === 'compact'
    ? { track: 'w-[26px] h-[15px]', knob: 'w-[11px] h-[11px]', tx: 'translate-x-[11px]' }
    : { track: 'w-[30px] h-[17px]', knob: 'w-[13px] h-[13px]', tx: 'translate-x-[13px]' }
  return (
    <button
      type="button"
      role="switch"
      aria-checked={!!checked}
      aria-label={ariaLabel}
      disabled={disabled}
      onClick={() => !disabled && onChange && onChange(!checked)}
      className={
        'relative rounded-full transition-colors ' +
        s.track + ' ' +
        (checked ? 'bg-[#e85d1f]' : 'bg-[#d6d3cb]') + (disabled ? ' opacity-45 cursor-not-allowed' : '')
      }
    >
      <span
        className={
          'absolute top-[2px] left-[2px] rounded-full bg-white ' +
          'shadow-[0_1px_2px_rgba(20,20,16,.20)] transition-transform ' +
          s.knob + ' ' +
          (checked ? s.tx : '')
        }
      />
    </button>
  )
}

export function Toggle({ checked, onChange, label, hint, size = 'default', disabled = false }) {
  return (
    <label className={'grid grid-cols-[auto_1fr] gap-3 items-start py-2 ' + (disabled ? 'opacity-60 cursor-not-allowed' : 'cursor-pointer')}>
      <span className="mt-0.5">
        <ToggleSwitch checked={checked} onChange={onChange} ariaLabel={label} size={size} disabled={disabled}/>
      </span>
      <span>
        <span className="block text-[13px] font-medium text-[#1a1816] leading-tight">{label}</span>
        {hint && (
          <span className="block text-[12px] text-[#6b6862] leading-snug mt-0.5">{hint}</span>
        )}
      </span>
    </label>
  )
}
